import React from "react";
import PageHeader from "../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Reprocessamento de Documento" />;
}

export default GridHeader;
